import { useRef, useEffect, useCallback } from "react";

const ScreenPreview = ({
  htmlContent,
  styleContent,
  slots,
  selectedSlot,
  onSlotSelect,
}) => {
  const iframeRef = useRef(null);

  const injectOverlay = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe || !htmlContent) return;

    const doc = iframe.contentDocument;
    if (!doc) return;

    const isFullDocument =
      htmlContent.indexOf("<!DOCTYPE") >= 0 ||
      htmlContent.indexOf("<html") >= 0;

    const slotOverlayCss = `
      [data-kayros-slot] { outline: 1px dashed transparent; cursor: pointer; transition: outline-color 0.15s; }
      [data-kayros-slot]:hover { outline-color: #1890ff; }
      [data-kayros-slot].kayros-slot--selected { outline: 2px solid #1890ff; background: rgba(24, 144, 255, 0.05); }
      [data-kayros-slot].kayros-slot--bound { outline-color: #52c41a; }
    `;

    // Stylesheet lives on the version (styleContent): without it the preview
    // shows raw HTML while the runtime injects it.
    const sharedStyle = styleContent
      ? "<style>" + styleContent + "</style>"
      : "";

    doc.open();
    if (isFullDocument) {
      const injected = htmlContent.replace(
        "</head>",
        sharedStyle + "<style>" + slotOverlayCss + "</style></head>",
      );
      doc.write(injected);
    } else {
      doc.write(
        "<!DOCTYPE html><html><head><style>body { margin: 0; padding: 16px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }" +
          slotOverlayCss +
          "</style>" +
          sharedStyle +
          "</head><body><div class='kayros-screen'>" +
          htmlContent +
          "</div></body></html>",
      );
    }
    doc.close();

    const slotIndex = {};
    for (const slot of slots) {
      slotIndex[slot.id] = slot;
    }

    const slotElements = doc.querySelectorAll("[data-kayros-slot]");
    for (let i = 0; i < slotElements.length; i++) {
      const el = slotElements[i];
      const slotId = el.getAttribute("data-kayros-slot");
      const slot = slotIndex[slotId];

      if (slot && slot.binding && slot.binding.kind !== "unbound") {
        el.classList.add("kayros-slot--bound");
      }

      if (slotId === selectedSlot) {
        el.classList.add("kayros-slot--selected");
      }

      el.style.position = el.style.position || "relative";
      const overlay = doc.createElement("div");
      overlay.style.cssText =
        "position:absolute;top:0;left:0;right:0;bottom:0;cursor:pointer;z-index:9999;";
      overlay.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        onSlotSelect(slotId);
      });
      el.appendChild(overlay);
    }
  }, [htmlContent, styleContent, slots, selectedSlot, onSlotSelect]);

  useEffect(() => {
    injectOverlay();
  }, [injectOverlay]);

  if (!htmlContent) {
    return (
      <div className="screen-studio__empty">
        <p>Aucun contenu HTML. Générez un écran pour commencer.</p>
      </div>
    );
  }

  return (
    <iframe
      ref={iframeRef}
      title="Screen Preview"
      className="screen-studio__iframe"
      sandbox="allow-same-origin allow-scripts"
    />
  );
};

export default ScreenPreview;
